import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import moment from 'moment/min/moment-with-locales';

import { LOCALES_ROOT, SERVER_IS_NORWAY } from '~/library/config';
import { APP_TO_MOMENT_LOCALE } from '~/utils/constants';

const defaultLocale = window.sessionStorage.getItem('locale') || (SERVER_IS_NORWAY ? 'no' : 'en');
const getMomentLocale = (appLocale) => APP_TO_MOMENT_LOCALE[appLocale] || 'en';

moment.locale(getMomentLocale(defaultLocale));

i18n.use(XHR)
    .init({
        backend: {
            loadPath: `${LOCALES_ROOT}/{{lng}}/{{ns}}.json`,
        },
        fallbackLng: defaultLocale,
        load: 'languageOnly',
        debug: false,
        keySeparator: '....',
        nsSeparator: '::::',
    });
export default i18n;
